import React, { Component } from "react";

import { Route, Redirect } from "react-router-dom";

class ProtectedRoutes extends Component {
    constructor(props) {
        super(props);
    }

    isAuthenticated = () => {
        if (localStorage.getItem("accessToken")) return true;
        else return false;
    };

    render() {
        const { children, ...rest } = this.props;
        return <Route {...rest} render={() => (this.isAuthenticated() ? children : <Redirect to="/signin" />)} />;
    }
}

export default ProtectedRoutes;
